import React from 'react';
import AnimatedSection from './AnimatedSection';

const indicators = [
  'Built for Hospitality & Commerce',
  'AI-Powered Solutions',
  'Custom Enterprise Software',
  'Scalable Cloud Infrastructure',
  'Enterprise Security',
];

const SocialProof: React.FC = () => {
  return (
    <section className="relative border-y border-surface-border bg-surface-secondary/40 py-10 md:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection animation="fade-in">
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-5 md:gap-x-14">
            {indicators.map((label) => (
              <div key={label} className="flex items-center gap-2.5">
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500 shrink-0" />
                <span className="text-sm md:text-base text-muted font-medium whitespace-nowrap">{label}</span>
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default SocialProof;
